import { Menu, UserAvatar } from '@pocketlaw/tetris';
import { DocumentMetadataPropertyReferenceEnum, } from 'shared/domains/apollo/generated/types';
export function ListSelectionListItem(props) {
    var _a;
    const { item, reference, selected, handleSelect } = props;
    if ((_a = item.groupValues) === null || _a === void 0 ? void 0 : _a.length) {
        return (<Menu.ItemNested target={item.text}>
        {item.groupValues.map((groupValue) => (<Menu.Item selected={selected} key={groupValue.value} onClick={() => handleSelect(groupValue.value)}>
            {groupValue.text}
          </Menu.Item>))}
      </Menu.ItemNested>);
    }
    return (<Menu.Item key={item.value} selected={selected} onClick={() => handleSelect(item.value)}>
      {reference === DocumentMetadataPropertyReferenceEnum.User ? (<UserAvatar size="xs" title={item.text}/>) : (item.text)}
    </Menu.Item>);
}
